import { Recordatorio } from '../../domain/entities/Recordatorio';
import { RecordatorioRepository } from '../../domain/repositories/RecordatorioRepository';

export class RecordatorioService {
  constructor(private recordatorioRepository: RecordatorioRepository) {}

  async findByNumero(nroRecordatorio: number): Promise<Recordatorio | null> {
    try {
      return await this.recordatorioRepository.findByNumero(nroRecordatorio);
    } catch (error) {
      throw new Error(`Error al buscar el recordatorio: ${error instanceof Error ? error.message : String(error)}`);
    }
  }

  async registerPayment(data: {
    uuid: string;
    nroRecordatorio: number;
    valorPagado: number;
    identificacion: string;
    estado: string;
    fechaPago: string;
    medioPago: string;
    nombreCliente?: string;
    codigoFideicomiso?: number;
    oficina?: number;
    id?: number;
    intereses?: number;
    detalleFactura?: string;
    fechaFactura?: string;
    valorTotal?: number;
    valorSaldo?: number;
  }): Promise<{ id: number }> {
    try {
      return await this.recordatorioRepository.registerPayment(data);
    } catch (error) {
      throw new Error(`Error al registrar el pago: ${error instanceof Error ? error.message : String(error)}`);
    }
  }
}
